import { render, staticRenderFns } from "./AdminContentCampaignShowTabular.vue?vue&type=template&id=7c88e63a&scoped=true&"
import script from "./AdminContentCampaignShowTabular.vue?vue&type=script&lang=ts&"
export * from "./AdminContentCampaignShowTabular.vue?vue&type=script&lang=ts&"
import style0 from "./AdminContentCampaignShowTabular.vue?vue&type=style&index=0&id=7c88e63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88e63a",
  null
  
)

export default component.exports